import { get, getOr, set, omit, keyBy } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import {
  fetchInventoryPackageSkus,
  addInventoryPackageSku,
  deleteInventoryPackageSku
} from '../../sagas/routines';

const initialState = {
  byPackageId: {},
  fetched: false,
  fetching: false,
  fetchingError: null,
  saved: false,
  saving: false,
  savingError: null,
  deleting: false,
  deleted: false,
  deletingError: null
};

export const fetchSkusHandler = routine => ({
  [routine.TRIGGER]: set('fetching', true),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    byPackageId: set(
      get('items.0.itemId', response),
      keyBy('id', response.items),
      state.byPackageId
    )
  }),
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: set('fetching', false)
});

export const addSkuHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, saving: true, saved: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) => {
    const { itemId, id } = response;
    return {
      ...state,
      saved: true,
      byPackageId: {
        ...state.byPackageId,
        [itemId]: { ...getOr({}, itemId, state.byPackageId), [id]: response }
      }
    };
  },
  [routine.FAILURE]: (state, error) => set('savingError', error, state),
  [routine.FULFILL]: set('saving', false)
});

export const deleteSkuHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, deleting: true, deleted: false }),
  [routine.SUCCESS]: (state, { payload: { id, skuId } }) => ({
    ...state,
    deleted: true,
    byPackageId: {
      ...state.byPackageId,
      [id]: omit(skuId, state.byPackageId[id])
    }
  }),
  [routine.FAILURE]: (state, { error }) => set('deletingError', error, state),
  [routine.FULFILL]: set('deleting', false)
});

export default createReducer(initialState, {
  ...fetchSkusHandler(fetchInventoryPackageSkus),
  ...addSkuHandler(addInventoryPackageSku),
  ...deleteSkuHandler(deleteInventoryPackageSku)
});
